import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks "Return to current position" button',
  name: 'clicked_return_to_current_position_button',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
